import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environment';

import { StorageService } from '@core/services/util/storage.service';
import { UtilityService } from '@core/services/util/utility.service';

import { OrderStatusApiResponse } from '@app/shared/models/api-response/order-status';
import { CancelOrderReponse } from '@app/shared/models/api-response/cancel-order';

@Injectable({
    providedIn: 'root'
})
export class OrderApiService {
    private apiUrl: string;
    private cartApiUrl: string;

    constructor(private http: HttpClient, private storageService: StorageService, private utilityService: UtilityService) {
        this.apiUrl = environment.apiUrl;
        this.cartApiUrl = environment.c3pServiceUrl;
    }

    getOrderSummary(params) {
        const headers = this.utilityService.getAuthHeaders('signed');
        return this.http.get(this.apiUrl + '/v4/order/summary', { params, headers });
    }

    getOrderStatus(tracking_id: string, merchant_order_id: string) {
        const headers = this.utilityService.getAuthHeaders('signed');
        return this.http.get<OrderStatusApiResponse>(this.cartApiUrl + '/order/status', {
            params: { tracking_id, merchant_order_id },
            headers
        });
    }

    cancelOrder(tracking_id: string) {
        const headers = this.utilityService.getAuthHeaders('signed');
        return this.http.post<CancelOrderReponse>(this.apiUrl + '/order/cancel', { tracking_id }, { headers });
    }

    downloadInvoice(encrypted_tracking_id) {
        const headers = this.utilityService.getAuthHeaders();
        return this.http.get(`${this.apiUrl}/order_details/${encrypted_tracking_id}`, { responseType: 'arraybuffer', headers });
    }

    cancel(orderId, status) {
        const headers = this.utilityService.getAuthHeaders();
        return this.http.put(`${this.apiUrl}/order/${orderId}/order_status`, { status }, { headers });
    }

    getCustomerOrders(page = 1) {
        const params = {
            outlet_id: this.storageService.get('outlet_id'),
            page: String(page),
            ver: 1
        };

        const headers = this.utilityService.getAuthHeaders('signed');

        return this.http.get(`${this.apiUrl}/v3/order/customer_orders`, { params, headers });
    }

    getLiveOrders(orderId) {
        const params = {
            outlet_id: this.storageService.get('outlet_id'),
            tracking_id: orderId,
            ver: 1
        };
        const headers = this.utilityService.getAuthHeaders('signed');

        return this.http.get(`${this.apiUrl}/v3/order/order_tracking_details`, { params, headers });
    }

    getLiveOrdersWithoutAuth(trackingId) {
        const params = new HttpParams().set('tracking_id', trackingId);
        return this.http.get(`${this.apiUrl}/v2/order/order_tracking_details_unauthenticated`, { params });
    }

    getCustomerRefunds(page_no = 1) {
        const params = { page_no };
        const headers = this.utilityService.getAuthHeaders('signed');
        return this.http.get(`${environment.c3pServiceUrl}/v2/refund_details/customer_refunds`, { params, headers });
    }

    getActiveRefundCount() {
        const headers = this.utilityService.getAuthHeaders('signed');
        return this.http.get(`${environment.c3pServiceUrl}/v2/refund_details/active_refunds`, { headers });
    }

    getRefundDetails(tracking_id: string) {
        const params = { tracking_id };
        const headers = this.utilityService.getAuthHeaders('signed');

        return this.http.get(`${environment.c3pServiceUrl}/v2/refund_details`, { params, headers });
    }

    submitDeliveryConfirmationResponse(trackingId: string, value: boolean) {
        const headers = this.utilityService.getAuthHeaders('signed');

        return this.http
            .post(
                `${environment.apiUrl}/order/${trackingId}/order_delivery_report`,
                {
                    confirmation: value
                },
                {
                    headers
                }
            );
    }
}
